// Webpack Imports
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
/*parallasse*/
function handleIntersection(entries, observer) {
    entries.forEach(entry => {
       // const result = document.getElementById('result');
        if (entry.isIntersecting) {
            console.log('The element is visible in the viewport!');
            entry.target.classList.add('visible');
        } else {
            //result.innerText = 'The element is not visible in the viewport!';
        }
    });
}
function handleIntersectionM(entries, observer) {
    entries.forEach(entry => {
        // const result = document.getElementById('result');
        if (entry.isIntersecting) {
            console.log('The element is visible in the viewport!');
            var childentries=entry.target.querySelectorAll('.highlight-content,.box-content,.left,.swiper-slide:first-child,.highlight-image, .highlight-cta');
            childentries.forEach(childentry => {
                childentry.classList.add('visible');
            });

        } else {
            //result.innerText = ,.
        }
    });
}
document.addEventListener( 'wpcf7mailsent', function( event ) {
    var form = event.target.closest('.wpcf7-form');

    console.log('wpcf7mailsent', event);

    if (!form) {
        return;
    }

    form.querySelectorAll('.container').forEach(function (container) {
        container.style.display = 'none';
    });

    setTimeout(function () {
        var output = form.querySelector('.wpcf7-response-output');

        if (output) {
            output.innerHTML = '<b>Grazie per averci contattato!</b><br/><p>Abbiamo ricevuto la tua richiesta e ti ricontatteremo entro 24 ore lavorative.</p><p>Se ci hai scritto durante il weekend o nei giorni di chiusura dello studio, i tempi di risposta potrebbero essere leggermente più lunghi.</p>';
            output.removeAttribute('aria-hidden');
        }
    }, 0);
})



const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0.3
});
const targetElements = document.querySelectorAll('.swiperInPage ,.swiperSlider,.block--tech-data .cont-img,.paragraph-with-image .swiper-slide:first-child img ,.single-trainer-static img')
targetElements.forEach(targetElement => observer.observe(targetElement));

const observerM = new IntersectionObserver(handleIntersectionM, {

    root: null,
    threshold: 0.3
});
const targetElementsM = document.querySelectorAll('.block--box ,.block--trainers, .block--placements,.block--highlights')
targetElementsM.forEach(targetElement => observerM.observe(targetElement));


(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});
	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();
//if (document.getElementById('headerSlider')) {
    /*var swiperGallery= new Swiper('.swiperGallery', {
            direction: 'horizontal',
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                 clickable: true,
              },
            slidesPerView: 1,
            spaceBetween: 0,
            centered: true,
            speed: 2000,
            autoplay:false,
            navigation: {
                nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev',
            },

            on: {
                init: function () {
                    if (!this.isLocked) {
                       // document.getElementByClassname('headerSlider').classList.add('has-multiple-slides');
                    }
                }
            }
        });*/
        var swiperHeader = new Swiper('.swiperHeader', {
            direction: 'horizontal',
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            slidesPerView: 1,
            spaceBetween: 0,
            centered: true,
            speed: 1000,
            autoplay: false,
            navigation: false,

            on: {
                init: function () {
                    if (!this.isLocked) {
                        //this.classList.add('has-multiple-slides');

                    }
                }
            }
        });
        var swiperSlider = new Swiper('.swiperInPage', {
            direction: 'horizontal',
            loop: true,
            pagination: false,
            slidesPerView: 1,
            spaceBetween: 0,
            centered: true,
            speed: 2000,
            autoplay:{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                stopOnLastSlide:false
              },
            navigation:true,

            on: {
                init: function () {
                    if (!this.isLocked) {
                       // document.getElementByClassname('headerSlider').classList.add('has-multiple-slides');
                    }
                }
            }
        });

        /*$(window).resize(function () {
            console.log("resize");
            swiperHeader.update();
        });
        $(".swiper.swiperHeader  ").each(function(elem, target){
            var swp = target.swiper;
            $(this).hover(function() {

                swp.autoplay.stop();
            }, function() {

                swp.autoplay.start();
            });
        });*/
    //}
var modalContact = document.getElementById('modalContact');
var myModalContact = new bootstrap.Modal(modalContact, {});
var enableLocalContactValidation = false;
var requiredMessage = 'Compila questo campo.';
var emailMessage = 'Inserisci un indirizzo email valido.';

function setContactFieldCopy(form, name, label, placeholder) {
    var field = form.querySelector('[name="' + name + '"]');

    if (!field) {
        return;
    }

    field.dataset.placeholder = placeholder;
    field.placeholder = '';
    field.removeAttribute('placeholder');

    var wrapper = field.closest('.form-wrapper');
    var labelElement = wrapper ? wrapper.querySelector('label') : null;

    if (labelElement) {
        labelElement.textContent = label;
    }
}

function applyContactFormCopy(form) {
    setContactFieldCopy(form, 'your-name', 'Nome *', 'Inserisci il tuo nome');
    setContactFieldCopy(form, 'your-lastname', 'Cognome *', 'Inserisci il tuo cognome');
    setContactFieldCopy(form, 'your-email', 'Email *', 'es. nome@email.com');
    setContactFieldCopy(form, 'your-role', 'Desidero essere ricontattato per telefono', 'es. 333 1234567');
    setContactFieldCopy(form, 'your-message', 'Vuoi indicarci qualcosa?', 'Raccontaci brevemente il motivo della visita\no eventuali esigenze particolari.');

    var submit = form.querySelector('[type="submit"]');
    if (submit) {
        submit.value = 'Invia richiesta';
        submit.setAttribute('value', 'Invia richiesta');
    }

    var submitWrapper = submit ? submit.closest('.form-wrapper') : null;
    var row = submitWrapper ? submitWrapper.closest('.row') : null;

    if (row) {
        var note = form.querySelector('.required-note') || document.createElement('p');
        note.className = 'required-note text-sm';
        note.textContent = '*Campi obbligatori';
        row.classList.add('contact-submit-row');
        row.insertBefore(note, submitWrapper);
    }
}

function clearContactFieldError(field) {
    var wrap = field.closest('.wpcf7-form-control-wrap');

    field.classList.remove('wpcf7-not-valid');
    field.setAttribute('aria-invalid', 'false');

    if (wrap) {
        wrap.querySelectorAll('.wpcf7-not-valid-tip').forEach(function (tip) {
            tip.remove();
        });
    }
}

function setContactFieldError(field, message) {
    var wrap = field.closest('.wpcf7-form-control-wrap');

    clearContactFieldError(field);
    field.classList.add('wpcf7-not-valid');
    field.setAttribute('aria-invalid', 'true');

    if (wrap) {
        var tip = document.createElement('span');
        tip.className = 'wpcf7-not-valid-tip';
        tip.setAttribute('aria-hidden', 'true');
        tip.textContent = message;
        wrap.appendChild(tip);
    }
}

function validateContactField(field) {
    var isRequired = field.classList.contains('wpcf7-validates-as-required') || field.name === 'cf-optin';

    if (isRequired && field.type === 'checkbox' && !field.checked) {
        setContactFieldError(field, requiredMessage);
        return false;
    }

    if (isRequired && field.type !== 'checkbox' && !field.value.trim()) {
        setContactFieldError(field, requiredMessage);
        return false;
    }

    if (field.type === 'email' && field.value.trim() && !field.validity.valid) {
        setContactFieldError(field, emailMessage);
        return false;
    }

    clearContactFieldError(field);
    return true;
}

function validateContactForm(form) {
    return Array.from(form.querySelectorAll('input, textarea, select'))
        .filter(function (field) {
            return !['hidden', 'submit'].includes(field.type);
        })
        .map(validateContactField)
        .every(Boolean);
}

function translateContactMessages(form) {
    var translations = {
        'Please fill out this field.': requiredMessage,
        'Please enter an email address.': emailMessage,
        'One or more fields have an error. Please check and try again.': 'Uno o piu campi contengono errori. Controlla e riprova.',
        'You must accept the terms and conditions before sending your message.': 'Devi accettare le condizioni prima di inviare il messaggio.'
    };

    form.querySelectorAll('.wpcf7-not-valid-tip, .wpcf7-response-output').forEach(function (message) {
        var text = message.textContent.trim();

        if (translations[text]) {
            message.textContent = translations[text];
        }
    });
}

document.addEventListener('wpcf7invalid', function (event) {
    var form = event.target.closest('.wpcf7-form');

    if (!form) {
        return;
    }

    setTimeout(function () {
        translateContactMessages(form);
    }, 0);
});

modalContact.addEventListener('show.bs.modal', function () {
    var form = modalContact.querySelector('.wpcf7-form');
    if (!form) {
        return;
    }

    form.classList.remove('invalid', 'sent', 'failed', 'spam', 'unaccepted', 'submitting');
    form.classList.add('init');
    form.dataset.status = 'init';
    form.reset();
    form.querySelectorAll('input, textarea, select').forEach(function (field) {
        if (field.type === 'checkbox' || field.type === 'radio') {
            field.checked = false;
        } else if (field.type !== 'hidden' && field.type !== 'submit') {
            field.value = '';
        }
    });
    form.querySelectorAll('label.focused').forEach(function (label) {
        label.classList.remove('focused');
    });
    form.querySelectorAll('.container').forEach(function (container) {
        container.style.display = '';
    });
    form.querySelectorAll('.wpcf7-not-valid').forEach(function (field) {
        field.classList.remove('wpcf7-not-valid');
        field.setAttribute('aria-invalid', 'false');
    });
    form.querySelectorAll('.wpcf7-not-valid-tip').forEach(function (tip) {
        tip.remove();
    });
    form.querySelectorAll('[type="submit"]').forEach(function (submit) {
        submit.disabled = false;
    });

    var output = form.querySelector('.wpcf7-response-output');
    if (output) {
        output.innerHTML = '';
        output.setAttribute('aria-hidden', 'true');
    }

    applyContactFormCopy(form);
});
modalContact.addEventListener('blur', function (event) {
    if (!enableLocalContactValidation) {
        return;
    }

    if (event.target.matches('input, textarea, select')) {
        validateContactField(event.target);
    }
}, true);
modalContact.addEventListener('focus', function (event) {
    if (!event.target.matches('input, textarea')) {
        return;
    }

    setTimeout(function () {
        event.target.placeholder = event.target.dataset.placeholder || '';
    }, 0);
}, true);
modalContact.addEventListener('blur', function (event) {
    if (event.target.matches('input, textarea') && !event.target.value) {
        event.target.placeholder = '';
        event.target.removeAttribute('placeholder');
    }
}, true);
modalContact.addEventListener('change', function (event) {
    if (!enableLocalContactValidation) {
        return;
    }

    if (event.target.matches('input, textarea, select')) {
        validateContactField(event.target);
    }
});
modalContact.addEventListener('submit', function (event) {
    if (enableLocalContactValidation && !validateContactForm(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
    }

    if (!window.wpcf7) {
        var output = event.target.querySelector('.wpcf7-response-output');

        event.preventDefault();
        event.stopImmediatePropagation();

        if (output) {
            output.innerHTML = 'Invio momentaneamente non disponibile. Riprova tra poco.';
            output.removeAttribute('aria-hidden');
        }
    }
}, true);
var elements=document.querySelectorAll('[href="#visita"]');
elements.forEach(element => {
    element.onclick = function(){myModalContact.show();};
})
window.addEventListener("load", function(){
    //("ready");

    //
    if (document.getElementById('trainerBlockCarousel')) {

        var swiperTrainers = new Swiper('#trainerBlockCarousel', {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1.25,
            spaceBetween: 20,
            centered: false,
            slidesOffsetAfter: 0,
            //touchStartPreventDefault: false,
            autoHeight: true,
            breakpoints: {
                782: {
                    slidesPerView: 3.5, spaceBetween: 10,
                }
            },

            scrollbar:false/* {
                el: '.swiper-scrollbar', draggable: true
            }*/,
            on: {
                touchStart: function (swiper, event) {
                    console.log("start");
                    // Triggered continually while dragging
                    mouseDown=true;
                    console.log(mouseDown);
                    showHideCursor()
                },
                touchEnd: function (swiper, event) {
                    // Triggered when the drag is released
                    console.log("end");
                    mouseDown=false;
                   showHideCursor()
                },
                init: function () {
                    if (!this.isLocked) {
                        document.getElementById('trainerBlockCarousel').classList.add('has-multiple-slides');
                    }
                }
            }
        });

        /* $(window).resize(function () {
          console.log("resize");
             swiperTrainers.update();
         });*/

    }
});
document.onreadystatechange = function () {
   // myModalContact.show();
};
    document.addEventListener("DOMContentLoaded", function(){
    // make it as accordion for smaller screens
      //  alert("readyDOM");

    if (window.innerWidth > 992) {

    	document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){

    		everyitem.addEventListener('mouseover', function(e){

    			let el_link = this.querySelector('a[data-bs-toggle]');

    			if(el_link != null){
    				let nextEl = el_link.nextElementSibling;
    				el_link.classList.add('show');
    				nextEl.classList.add('show');
    			}

    		});
    		everyitem.addEventListener('mouseleave', function(e){
    			let el_link = this.querySelector('a[data-bs-toggle]');

    			if(el_link != null){
    				let nextEl = el_link.nextElementSibling;
    				el_link.classList.remove('show');
    				nextEl.classList.remove('show');
    			}


    		})
    	});

    }
    // end if innerWidth
    });
      var swiperGallery = new Swiper(".swiperGallery",{
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                stopOnLastSlide:true
              },
               loop: true,
              pagination: {
              el: ".swiper-pagination",
              dynamicBullets: true,
                clickable: true,
                speed: 2000,

            },
          });

if (document.getElementById('placementBlockCarousel')) {
        var swiperPlacements = new Swiper('#placementBlockCarousel', {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            centered: false,
            height: 'auto',
            slidesOffsetAfter: 0,
            scrollbar:false/* {
                el: '.swiper-scrollbar', draggable: true
            }*/,

            on: {
                init: function () {
                    if (!this.isLocked) {
                        document.getElementById('placementBlockCarousel').classList.add('has-multiple-slides');
                    }
                }
            }
        });

       /* $(window).resize(function () {
         console.log("resize");
            swiperPlacements.update();
        });*/

    }

    if (document.getElementById('numbersBlockCarousel')) {
            var swiperNumbers = new Swiper('#numbersBlockCarousel', {
                direction: 'horizontal',
                loop: false,
                slidesPerView: 1.3,
                spaceBetween: 10,
                centered: true,
                height: 'auto',
                //slidesOffsetAfter: 100,
                breakpoints: {
                    768: {
                      slidesPerView: 2 },
                      1024: {
                                            slidesPerView: 3 },
                  },
                scrollbar: {
                    el: '.swiper-scrollbar', draggable: true
                },

                on: {
                    init: function () {
                        if (!this.isLocked) {
                            document.getElementById('numbersBlockCarousel').classList.add('has-multiple-slides');
                        }
                    }
                }
            });

           /* $(window).resize(function () {
             console.log("resize");
                swiperPlacements.update();
            });*/

        }
    const formsWithAnimatedLabels = document.querySelectorAll(".form-with-animated-labels");
    const focusedClass = "focused";
    for (const form of formsWithAnimatedLabels) {
        const formControls = form.querySelectorAll('[type="text"], [type="email"], textarea');
        for (const formControl of formControls) {
            formControl.addEventListener("focus", function () {
                this.parentElement.nextElementSibling.classList.add(focusedClass);
                /*console.log('ehi');*/
            });
            formControl.addEventListener("blur", function () {
                if (!this.value) {
                    this.parentElement.nextElementSibling.classList.remove(focusedClass);
                }
            });
        }
        form.parentElement.addEventListener("wpcf7mailsent", function () {
            const labels = document.querySelectorAll(".focused");
            for (const label of labels) {
                label.classList.remove(focusedClass);
            }
        });
    }
    $(function () {
    var intervals=[];
    var counters=[];
    var image;
            function swapImages(index){

                $(".tech-data-item").removeClass("static");

                //console.log("swap_"+index+"_"+(counters[index]));
                $('.block--tech-data').eq(index).find("a.tech-data-item").removeClass("active");
                //console.log($('.block--tech-data').eq(index).find("a").eq(counters[index]).attr("data-img"));
                $('.block--tech-data').eq(index).find(".last.cta a").attr("href",$('.block--tech-data').eq(index).find("a.tech-data-item").eq(counters[index]).attr("data-href"));
                $('.block--tech-data').eq(index).find(".last.cta span").html($('.block--tech-data').eq(index).find("a.tech-data-item").eq(counters[index]).attr("data-title"));

                $('.block--tech-data').eq(index).find(".content p").html($('.block--tech-data').eq(index).find("a.tech-data-item").eq(counters[index]).attr("data-text"));
                //$('.block--tech-data').eq(index).find("img").attr("src",$('.block--tech-data').eq(index).find("a.tech-data-item").eq(counters[index]).attr("data-img"))
                image=$('.block--tech-data').eq(index).find("a.tech-data-item").eq(counters[index]).attr("data-img");

                var virtualimage = new Image();
                console.log(image);
                virtualimage.onload = function() {
                        $('.block--tech-data').eq(index).find("img").fadeOut('fast',function(){
                                                $(this).attr('src', image).fadeIn('fast');
                                             });
                    }
                    virtualimage.src = image;
                /*.attr('src', image);*/

                $('.block--tech-data').eq(index).find("a.tech-data-item").eq(counters[index]).addClass("active");
                console.log("-------------");
                console.log(index);
                 console.log(counters[index]);
                 console.log(counters[index]<$('.block--tech-data').eq(index).find("a.tech-data-item").length-1);
                 console.log("-------------");
                if(counters[index]< $('.block--tech-data').eq(index).find("a.tech-data-item").length-1){
                      counters[index]++;
                }else{
                    counters[index]=0;
                }
                //clearInterval(intervals[index]);
            }
            $(".block--tech-data.auto").each(function( index ) {
                $(this).attr("data-index", index  );

                counters[index]=0;
                swapImages(index);
                intervals[index]=setInterval(swapImages,7000,index);
                $(this).find('a.tech-data-item').each(function (index, element) {
                     //console.log( "a_"+index  );
                      $(this).on("mouseenter", function (e) {
                            console.log($(this).closest(".block--tech-data.auto").attr("data-index"));
                            clearInterval(intervals[Number($(this).closest(".block--tech-data.auto").attr("data-index"))]);
                            counters[Number($(this).closest(".block--tech-data.auto").attr("data-index"))]=Number($(this).attr("data-index"));
                            console.log("-----");
                            console.log($(this).closest(".block--tech-data.auto").attr("data-index"));
                            console.log(Number($(this).attr("data-index")));
                            console.log("-----");
                            swapImages(Number($(this).closest(".block--tech-data.auto").attr("data-index")));
                            $(this).addClass("static");
                      });
                      $(this).on("mouseleave", function (e) {
                           //console.log($(this).closest(".block--tech-data.auto").attr("data-index")))
                           intervals[Number($(this).closest(".block--tech-data.auto").attr("data-index"))]=setInterval(swapImages,7000,Number($(this).closest(".block--tech-data.auto").attr("data-index")));
                       });
                });
             });

             $(window).on('load', function () {
                 if (!$(".block--faqs ul li:first-child .js-accordion__title").hasClass("js-accordion-active")) {
                     $(".block--faqs ul li:first-child .js-accordion__title").trigger("click");
                 }
             })
        $(".navbar-close").on("click", function (e) {
            console.log("click");
            $('.navbar-collapse').removeClass("show");

        })
        $(".navbar-toggler").on("click", function (e) {
            console.log("click-tog");
            $('.navbar-collapse').addClass("show");

        })
         $(".js-accordion__title").on("click", function (e) {

             e.preventDefault();
             var $this = $(this);

             if (!$this.hasClass("js-accordion-active")) {
                 $this.parent().parent().find(".js-accordion__content").slideUp(400);
                 $this.parent().parent().find(".js-accordion__title").removeClass("js-accordion-active");
             }

             $this.toggleClass("js-accordion-active");
             $this.next().slideToggle();
         });
          });


var divName = 'mousefollow'; // div that is to follow the mouse (must be position:absolute)
var offX = 15;          // X offset from mouse position
var offY = 15;          // Y offset from mouse position
const sliderOver = document.getElementById("trainerBlockCarousel");
let currentMouseX = 0;
let currentMouseY = 0;
let viewcursor=false;
let mouseDown = 0;
function showHideCursor(){

    var obj = document.getElementById(divName).style;

    var divRect = document.getElementById('trainerBlockCarousel').getBoundingClientRect();
    if (event.clientX >= divRect.left && event.clientX <= divRect.right &&
        event.clientY >= divRect.top && event.clientY <= divRect.bottom) {
        viewcursor=true;
    }else{
        viewcursor=false;
    }
 
    if(viewcursor && !mouseDown){
        obj.display = 'block';
        // console.log("draggo"+currentMouseX+offX)
        // clientX is the distance from the left edge of the visible viewport
        // window.scrollX represents how much the page has been scrolled horizontally
        currentMouseX = event.clientX + window.scrollX;
        currentMouseY = event.clientY + window.scrollY;
        obj.left = (currentMouseX+offX )+ 'px';
        obj.top = (currentMouseY +offY) +'px';
    }else{
        obj.display = 'none';
    }
}
window.addEventListener('mousemove', (event) => {
    showHideCursor()
});

/*sliderOver.addEventListener("mouseenter", (event) => {
    // highlight the mouseenter target
    viewcursor=true;

});*/



window.addEventListener('mousedown', function(event) {
    console.log('Pressione del mouse rilevata!');
    console.log('Pulsante:', event.button); // 0: Sinistro, 1: Centrale, 2: Destro
    console.log('Elemento cliccato:', event.target);

    // Puoi ottenere le coordinate esatte del clic
    console.log(`X: ${event.clientX}, Y: ${event.clientY}`);
}, { capture: true });
